<h2 mat-dialog-title>Tipi segnalazione – {{ user.username }}</h2>
<mat-dialog-content>
  @if (loading) {
    <div class="d-flex justify-content-center p-3">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else if (errorMessage && !saving) {
    <p class="text-danger mb-2">{{ errorMessage }}</p>
  } @else {
    <p class="mb-3">Seleziona i tipi segnalazione da associare all'utente.</p>
    <div class="tipo-list">
      @for (t of allTipi; track t.id) {
        <div class="tipo-row">
          <mat-checkbox [checked]="isSelected(t)" (change)="toggle(t)">
            {{ t.codice || '—' }} – {{ t.descrizione || '—' }}
          </mat-checkbox>
        </div>
      }
      @if (allTipi.length === 0) {
        <p class="text-muted">Nessun tipo segnalazione disponibile.</p>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
  @if (!loading) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
      {{ saving ? 'Salvataggio...' : 'Salva' }}
    </button>
  }
</mat-dialog-actions>
